angular.module('sample.widgets.newSearch',
        [
            'adf.provider',
            "ngResource",
            "ivpusic.cookie",
            "EICDataStream3.resources",
            "ui.router",
            'ui.bootstrap.tooltip'
        ])
    .config(['dashboardProvider', function(dashboardProvider) {
        dashboardProvider
            .widget('newSearch',
                {
                    id: 'newSearch',
                    title: 'New Search',
                    description: 'Start a new search - select whether to search for projects or contract awards',
                    controller: 'NewSearchController',
                    //   controllerAs: 'list',
                    templateUrl: '/app-ds3/dashboard/widgets/newSearch/newSearch.partial.html' //,
//            edit:         {
//              templateUrl: '/app/angular-dashboard-framework/widgets/linklist/edit.html',
//              reload:      false,
//              controller:  'linklistEditCtrl'
//            }
                });
    }])
    .controller('NewSearchController',
        [
            '$scope', '$rootScope', '$http', '$state', 'searchService',
            function($scope, $rootScope, $http, $state, searchService) {
                $scope.componentName = "NewSearchController";

                $scope.isMobile = window.innerWidth < 825;
                
                $scope.newProjectSearch = function() {
                    searchService.searchType = "project";
                    $state.go("search.forProjects");
                };

                $scope.newOperatingCompanySearch = function() {

                };


                $scope.newContractAwardSearch = function() {
                    searchService.searchType = "contractAward";
                    $state.go("search.forContractAwards");
                };

                $scope.$on('$viewContentLoaded',
                    function() {
                    });
                $scope.$on('$destroy',
                    function() {
                    });
            }
        ]);


